﻿

$(function () {

    var MyOrders = function () {

        var orderPages = 0;
        var myOrdersPage = 0;


        function hideLoader() {
            $('.loader-wrapper').hide();
            $('#js-show-more-orders').prop('disabled', false);
        }

        function showLoader() {
            $('.loader-wrapper').show();
            $('#js-show-more-orders').prop('disabled', true);
        }

        var loadMyOrders = function (index) {
            showLoader();
            $.ajax({
                dataType: "json",
                url: "/api/myorders/getmyorders",
                type: "get",
                data: { index: index, orderNo: $("#orderNo").val() },
                cache: false,
                success: function (data) {
                    if (data) {
                        if (data.length > 0) {
                            var template = $.templates("#my-orders-template");
                            var htmlOutput = template.render(data);
                            $(".js-my-orders").append(htmlOutput);
                            $(".js-my-orders-text").removeClass("hidden");
                            $(".js-export-excel").removeClass("hidden");

                            //index starts at 0
                            if (index < orderPages - 1) {
                                $("#js-show-more-orders").removeClass("hidden");

                            } else {
                                $("#js-show-more-orders").addClass("hidden");
                            }
                            for (let item of data) {
                                if (item.OrderStatus.trim() !== "Fakturerad") {
                                    $(`#order-${item.Index} .tooltip`).attr("style", "display: none;");
                                }
                            }
                        }
                    }
                    if (data != null  && data.length === 0) {
                        $("#js-show-more-orders").addClass("hidden");
                    }
                    hideLoader();
                },
                error: function () {
                    hideLoader();
                }
            });
        };

        var loadPagesCount = function () {
            showLoader();
            $.ajax({
                dataType: "json",
                url: "/api/myorders/getmyorderspages",
                type: "get",
                data: { orderNo: $("#orderNo").val() },
                cache: false,
                success: function (data) {
                    hideLoader();
                    if (data) {
                        orderPages = data;
                        if (data > 0) {
                            loadMyOrders(0);
                        }
                    }
                    else {
                        $("#dv-err-order").removeAttr("hidden");
                        $(".lm__block-box").removeClass("has-separator");
                    }
                    if ($("#spn-iconimg").width() == 0) {
                        $("#spn-iconimg").attr("hidden", "hidden");
                    }
                },
                error: function () {
                    hideLoader();
                }
            });
        };

        $(".js-export-excel").on("click", function () {
            var url = $(this).data("url");
            location.href = url;
        });

        $("#js-show-more-orders").on("click", function () {
            myOrdersPage = myOrdersPage + 1;
            loadMyOrders(myOrdersPage);
        });

        $(document).on("click", ".js-get-order-confirmation", function () {
            var targetSelector = $(this).data("toggle-target");
            if ($(targetSelector).attr("aria-hidden") === "true") {
                var orderNr = $(this).data("order-number");
                var orderIndex = $(this).attr("aria-controls").replace("order-", "");
                checkOrderConfirmation(orderNr, orderIndex);
            }
        });

        var checkOrderConfirmation = function (orderNr, orderIndex) {
            $.ajax({
                dataType: "json",
                url: "/api/myorders/CheckIfOrderConfirmationExists",
                type: "get",
                data: { orderNo: orderNr },
                cache: false,
                success: function (data) {
                    if (data && data.Success) {
                        $(`#order-confirmation-container-${orderIndex}`).removeAttr("hidden");
                    }
                },
                error: function () {
                    $(`#order-confirmation-container-${orderIndex}`).attr("hidden", "hidden");
                }
            });
        };

        $(document).on("click", ".js-download-order-confirmation", function (e) {
            e.preventDefault();
            var orderNr = $(this).closest(".order-confirmation-container").data("order-number");
            window.open(`/api/myorders/DownloadOrderConfirmation?orderNo=${encodeURIComponent(orderNr)}`, "_blank");
        });

        $(document).on("click", ".js-get-invoice", function () {
            var targetSelector = $(this).data("toggle-target");
            if ($(targetSelector).attr("aria-hidden") === "true") {
                var orderNr = $(this).data("order-number");
                var orderLineNumber = $(this).data("order-line-number");
                var orderIndex = $(this).attr("aria-controls").replace("order-", "");
                checkInvoice(orderNr, orderLineNumber, orderIndex);
            }
        });

        var checkInvoice = function (orderNr, orderLineNumber, orderIndex) {
            $.ajax({
                dataType: "json",
                url: "/api/myorders/CheckIfInvoiceExists",
                type: "get",
                data: { orderNumber: orderNr, orderLineNumber },
                cache: false,
                success: function (data) {
                    if (data && data.Success) {
                        $(`#invoice-container-${orderIndex}`).removeAttr("hidden");
                    }
                },
                error: function () {
                    $(`#invoice-container-${orderIndex}`).attr("hidden", "hidden");
                }
            });
        };

        $(document).on("click", ".js-download-invoice", function (e) {
            e.preventDefault();
            var invoiceContainer = $(this).closest(".invoice-container");
            var orderNr = invoiceContainer.data("order-number");
            var orderLineNumber = invoiceContainer.data("order-line-number");
            window.open(`/api/myorders/DownloadInvoice?orderNumber=${encodeURIComponent(orderNr)}&orderLineNumber=${encodeURIComponent(orderLineNumber)}`, "_blank");
        });

        return {
            init: function () {
                if ($(".js-my-orders").length) {
                    loadPagesCount();
                }
                return false;
            }
        };
    };

    $(document).ready(function () {
        var myorders = new MyOrders();
        myorders.init();
    });

});